/**
 * Map Actions
 */
export const mapTypes = {
  activeCategoryFilterChanged : 'ACTIVE_CATEGORY_FILTER_CHANGED',
  locationFilterGeocoded      : 'LOCATION_FILTER_GEOCODED',
  locationFilterReset         : 'LOCATION_FILTER_RESET',
  locationsChanged            : 'LOCATIONS_CHANGED',
  resetActiveInfoWindowIndex  : 'RESET_ACTIVE_INFO_WINDOW_INDEX',
  setActiveInfoWindowIndex    : 'SET_ACTIVE_INFO_WINDOW_INDEX',
  setZoom                     : 'SET_ZOOM',
  toggleActiveProgram         : 'TOGGLE_ACTIVE_PROGRAM',
  toggleMobileMap             : 'TOGGLE_MOBILE_MAP',
  viewBoundsChanged           : 'VIEW_BOUNDS_CHANGED',
  viewCenterChanged           : 'VIEW_CENTER_CHANGED',
  viewZoomChanged             : 'VIEW_ZOOM_CHANGED',
}

/**
 * Map Action Creators
 */
const mapActions = {
  activeCategoryFilterChanged : function (category) { return { type: mapTypes.activeCategoryFilterChanged, payload: { category, }, }},
  locationFilterGeocoded      : function (location) { return { type: mapTypes.locationFilterGeocoded, payload: { location, }, } },
  locationFilterReset         : function () { return { type: mapTypes.locationFilterReset, } },
  locationsChanged            : function (locations, activeCat = null, returnMapState = null) { return { type: mapTypes.locationsChanged, payload: { locations, activeCat, returnMapState, }, } },
  resetActiveInfoWindowIndex  : function () { return { type: mapTypes.resetActiveInfoWindowIndex, } },
  setActiveInfoWindowIndex    : function (index) { return { type: mapTypes.setActiveInfoWindowIndex, payload: { index, }, } },
  setZoom                     : function (zoom) { return { type: mapTypes.setZoom, payload: { zoom, }, } },
  toggleActiveProgram         : function (id, type) { return {  type: mapTypes.toggleActiveProgram, payload: { id, type, },  } },
  toggleMobileMap             : function () { return { type: mapTypes.toggleMobileMap, } },
  viewBoundsChanged           : function (bounds) { return { type: mapTypes.viewBoundsChanged, payload: { bounds, }, } },
  viewCenterChanged           : function (center) { return { type: mapTypes.viewCenterChanged, payload: { center, }, }},
  viewZoomChanged             : function (zoom) { return { type: mapTypes.viewZoomChanged, payload: { zoom, }, } },
}

export default mapActions